module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_October2020-7e51b5c214be49f25cb159aab63f21f7.pdf";